import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1e8a193c = () => interopDefault(import('..\\pages\\claim-success.vue' /* webpackChunkName: "pages_claim-success" */))
const _716a9006 = () => interopDefault(import('..\\pages\\eligibility.vue' /* webpackChunkName: "pages_eligibility" */))
const _608a92f8 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _40fdef71 = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _6c1e275e = () => interopDefault(import('..\\pages\\not-eligible.vue' /* webpackChunkName: "pages_not-eligible" */))
const _3d564b54 = () => interopDefault(import('..\\pages\\patient-information.vue' /* webpackChunkName: "pages_patient-information" */))
const _3c6acdc6 = () => interopDefault(import('..\\pages\\print.vue' /* webpackChunkName: "pages_print" */))
const _b1250f0e = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _3dcb9c07 = () => interopDefault(import('..\\pages\\submit-claim.vue' /* webpackChunkName: "pages_submit-claim" */))
const _be7b551a = () => interopDefault(import('..\\pages\\success.vue' /* webpackChunkName: "pages_success" */))
const _f0435c54 = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _9368a0ce = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _934c71cc = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _931413c8 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _92f7e4c6 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _299c2a4c = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _1cc474c2 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/claim-success",
    component: _1e8a193c,
    name: "claim-success"
  }, {
    path: "/eligibility",
    component: _716a9006,
    name: "eligibility"
  }, {
    path: "/error",
    component: _608a92f8,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _40fdef71,
    name: "have-a-card"
  }, {
    path: "/not-eligible",
    component: _6c1e275e,
    name: "not-eligible"
  }, {
    path: "/patient-information",
    component: _3d564b54,
    name: "patient-information"
  }, {
    path: "/print",
    component: _3c6acdc6,
    name: "print"
  }, {
    path: "/rejection",
    component: _b1250f0e,
    name: "rejection"
  }, {
    path: "/submit-claim",
    component: _3dcb9c07,
    name: "submit-claim"
  }, {
    path: "/success",
    component: _be7b551a,
    name: "success"
  }, {
    path: "/upload-documents",
    component: _f0435c54,
    name: "upload-documents"
  }, {
    path: "/errors/400",
    component: _9368a0ce,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _934c71cc,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _931413c8,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _92f7e4c6,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _299c2a4c,
    name: "errors-500"
  }, {
    path: "/",
    component: _1cc474c2,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
